var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_c('img',{staticClass:"success-image",attrs:{"src":_vm.imageUrl}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('button',{on:{"click":_vm.closeModal}},[_vm._v("OK")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }